var render = function () {
var _obj, _obj$1, _obj$2, _obj$3, _obj$4;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    absolute: true,
    'z-10': true,
    'top-0 ltr:right-0 rtl:left-0': true,
    group: true,
    'ltr:rounded-tr-xl rtl:rounded-tl-xl': true,
  }},[_c('div',{staticClass:"transform"},[_c('div',{class:{
        'h-[29px] w-min': true,
        relative: true,
        flex: true,
        'ltr:pl-1 rtl:pr-1': true,
        'overflow-hidden': !_vm.isTouchable,
        'overflow-visible': _vm.isTouchable,
      }},[(_vm.xEditPost)?_c('div',{class:( _obj = {
          'transition-all': true,
          'ltr:translate-x-full rtl:-translate-x-full group-hover:translate-x-0': true,
          'ltr:rounded-bl-lg rtl:rounded-br-lg': true,
          'ltr:pr-[9px] rtl:pl-[9px]': true,
          'mt-[3px] ltr:mr-[-8px] rtl:ml-[-8px]': true,
          'transform ltr:translate-x-full rtl:-translate-x-full group-hover:translate-x-0': true,
          'flex justify-start items-start': true
        }, _obj[_vm.colorClasses[0]] = _vm.colorScheme === 'light', _obj[_vm.colorClasses[1]] = _vm.colorScheme === 'dark', _obj )},[(_vm.xOverlay)?_c('div',{class:( _obj$1 = {
            absolute: true,
            'ltr:left-[-4px] rtl:right-[-4px] top-[4px]': !_vm.isStream,
            'ltr:left-[-4px] rtl:right-[-4px] top-[8px]': _vm.isStream,
            'rtl:transform rtl:-scale-x-100': true
          }, _obj$1[_vm.colorClasses[2]] = _vm.colorScheme === 'light', _obj$1[_vm.colorClasses[3]] = _vm.colorScheme === 'dark', _obj$1 )}):_vm._e(),_vm._v(" "),_c('OzTextButton',{class:['font-semibold', 'text-12', 'py-0', 'px-1.5', 'h-4', 'mt-[5px]', 'mb-[5px]'],attrs:{"color-scheme":_vm.OzTextButtonColorScheme.SecondaryMuted,"dark-mode":_vm.colorScheme === 'dark',"text":_vm.__('Edit')},on:{"click":function($event){return _vm.$emit('edit')}}})],1):_vm._e(),_vm._v(" "),(_vm.xEditPost)?_c('div',{class:{
          'z-20': true,
          'opacity-0 group-hover:opacity-100': true,
          'transition-opacity': true,
          'h-4 mt-[8px] mb-[5px]': true,
          'w-[0px]': true,
          'border-r-[0.5px] border-solid': true,
          'border-dark-text-400': _vm.colorScheme === 'light',
          'border-light-text-400': _vm.colorScheme === 'dark',
        }}):_vm._e(),_vm._v(" "),_c('div',{class:( _obj$2 = {
          'w-5.5 mt-[3px] h-[26px]': true,
          'z-10': true,
          flex: true,
          relative: true,
          'overflow-visible': true,
          'justify-end': true,
          'ltr:rounded-bl-lg rtl:rounded-br-lg': true
        }, _obj$2[_vm.colorClasses[0]] = _vm.colorScheme === 'light', _obj$2[_vm.colorClasses[1]] = _vm.colorScheme === 'dark', _obj$2 )},[(_vm.xOverlay)?_c('div',{class:[
            ( _obj$3 = {
              absolute: true,
              'ltr:left-[-4px] rtl:right-[-4px] top-[4px]': !_vm.isStream,
              'ltr:left-[-4px] rtl:right-[-4px] top-[8px]': _vm.isStream,
              'rtl:transform rtl:-scale-x-100': true
            }, _obj$3[_vm.colorClasses[2]] = _vm.colorScheme === 'light', _obj$3[_vm.colorClasses[3]] = _vm.colorScheme === 'dark', _obj$3['transition opacity-100 group-hover:opacity-0'] =  _vm.xEditPost, _obj$3 ) ]}):_vm._e(),_vm._v(" "),_c('OzTextButton',{class:[
            'post-actions-button',
            'flex-shrink-0',

            // Want: 10px between 3 dots at the edge.
            // Assume 3 dots width is 2px.
            // DistanceFromEdge - (IconWidth - 3DotsWidth) / 2 = 10px - (16px - 2px) / 2 = 10px - 7px = 3px

            !_vm.isTouchable && [
              // ContainerHeight - ContainerMargin = 29px - 3px = 26px
              'h-[26px]',
              'w-5.5',
              'py-0',
              'px-[3px]' ],
            _vm.isTouchable && [
              'w-[48px]',
              'h-[48px]',
              // Total = 48px - 16px = 32px
              'pl-[29px] pr-[3px] rtl:pr-[29px] rtl:pl-[3px]',
              // Total = 32px
              'pt-[3px] pb-[29px]' ] ],attrs:{"color-scheme":_vm.OzTextButtonColorScheme.SecondaryMuted,"dark-mode":_vm.colorScheme === 'dark',"title":_vm.__('More post actions')},on:{"click":function($event){return _vm.$emit('dropdown')}}},[_c('OzIcon',{attrs:{"name":"more_vertical","size":16}})],1)],1)]),_vm._v(" "),(_vm.xOverlay)?_c('div',{class:[
        ( _obj$4 = {
          absolute: true,
          'bottom-[-4px] ltr:right-[7px] rtl:left-[7px]': !_vm.isStream,
          'bottom-[-4px] ltr:right-[11px] rtl:left-[11px]': _vm.isStream,
          'rtl:transform rtl:-scale-x-100': true
        }, _obj$4[_vm.colorClasses[2]] = _vm.colorScheme === 'light', _obj$4[_vm.colorClasses[3]] = _vm.colorScheme === 'dark', _obj$4 ) ]}):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }